// Turns API auth and payment failures into the app's AUTH_EVENTS. Registered in
// app.js's $httpProvider.interceptors.
angular.module('dentalLinks')

.factory('authInterceptor', ['$rootScope', '$q', 'AUTH_EVENTS', '$location', 'redirect', 'Auth', 'Logger', 'API_ENDPOINT', function ($rootScope, $q, AUTH_EVENTS, $location, redirect, Auth, Logger, API_ENDPOINT) {
    return {
        responseError: function (response) {
            // Only handle auth for our API requests; ignore 3rd-party 401s (e.g., Rollbar)
            var url = (response && response.config && response.config.url) || '';
            var isApiRequest = typeof url === 'string' && url.indexOf(API_ENDPOINT) === 0;
            if (!isApiRequest) {
                return $q.reject(response);
            }
            if (response.status === 401 || response.status === 403) {
                var path = $location.path();
                // if AJAX response intercepted, path will be of parent page
                
                switch (true) {
                    case path.startsWith('/sign_in'):
                    case path.startsWith('/register'):
                    case path.startsWith('/register_confirmation'):
                    case path.startsWith('/edit_password'):
                    case path.startsWith('/unsubscribe'):
                    case path.startsWith('/confirm_email'):
                    case path.startsWith('/error'):
                    case path.startsWith('/create_guest_referral'):
                    case path.startsWith('/guest_or_login'):
                        Auth.remove();
                        break;
                    default:
                        // For authentication errors that result in redirect to sign-in, 
                        $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated, {redirect: $location.url(), params: $location.search()});
                }
            } else if (response.status === 402) {
                Logger.log('error intercepted: status = ' + response.status);
                //don't allow to show referral in case of expired subscription
                $rootScope.$broadcast(AUTH_EVENTS.paymentRequired, {
                    redirect: redirect.path,
                    feature: response.data ? response.data.feature : undefined,
                    source: '402'
                });
            } else if (response.status === 409){
                Logger.log('error intercepted: status = ' + response.status);
                //don't allow to show referral for a user that doesn't have appropriate permission (his practice is neither origin nor destination for that referral)
                $rootScope.$broadcast(AUTH_EVENTS.forbidden, {redirect: redirect.path})
            } else {
                Logger.log('error intercepted: status = ' + response.status);
            }

            return $q.reject(response);
        }
    };
}]);
